export default __webpack_public_path__ + "be632bb416207cff9a10fc82531a8842.svg";